import type { RxJsonSchema } from 'rxdb';
import type { AssetSectionDefinationsList } from './assetSectionDefinition.types';

export const assetSectionDefinationsListSchema: RxJsonSchema<AssetSectionDefinationsList> = {
  type: 'object',
  version: 1,
  description: 'describes asset section Definations list',
  primaryKey: 'id',
  properties: {
    name: { type: 'string' },
    id: { type: 'string', maxLength: 36 },
    active: { type: ['boolean', 'null'] },
    dateCreated: { type: ['string', 'null'] },
    dateModified: { type: ['string', 'null'] },
    dynamicProperties: {
      type: ['array', 'null'],
      items: {
        type: ['object', 'null'],
        properties: {
          name: { type: ['string', 'null'] },
          id: { type: ['number', 'null'] },
          isFieldEditable: { type: ['boolean', 'null'] },
          lOV: {
            type: ['array', 'null'],
            items: {
              type: ['object', 'null'],
              properties: {
                value: { type: ['number', 'null'] },
                display: { type: ['string', 'null'] },
                sort: { type: ['number', 'null'] },
              },
            },
          },
        },
      },
    },
  },
};
